import { CheckCircle2, XCircle } from "lucide-react";

const StatusModal = ({ isOpen, onClose, type, message }) => {
  if (!isOpen) return null;

  const Icon = type === "success" ? CheckCircle2 : XCircle;
  const color = type === "success" ? "text-green-500" : "text-red-500";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40 p-4">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg text-center">
        <Icon className={`w-10 h-10 mx-auto mb-4 ${color}`} />
        <p className="text-lg font-semibold mb-2">
          {type === "success" ? "Success!" : "Error!"}
        </p>
        <p className="text-gray-700">{message}</p>
        <button
          onClick={onClose}
          className="mt-5 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Close
        </button>
      </div>
    </div>
  );
};
export default StatusModal;
